import DataFormSubmitPage from 'app/pages/DataFormSubmit';
import React from 'react';

const DanalPaymentMob = () => {
  return <DataFormSubmitPage />;
};

export default DanalPaymentMob;
